/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React from 'react';

import { DropdownDiv, ContainerDiv } from './styledComponents';
import { CHECKLIST_RESPONSE_NOTES } from 'config/constants';
import S from '../styles.scss';

const ChecklistResponseNote = props => <span>
  {props.canShow && <ContainerDiv>
    <DropdownDiv condition={props.canShow}>
      <div className={S.checklistContainer}>
        <p
          className={['flagNote', 'workroomNote', 'okToTextNote'].includes(props.noteKey) ?
            S.checklistUserNote : ''}
        >{CHECKLIST_RESPONSE_NOTES[props.noteKey]}</p>
      </div>
    </DropdownDiv>
  </ContainerDiv>}
</span>;

ChecklistResponseNote.defaultProps = { canShow: true };

ChecklistResponseNote.propTypes = {
  canShow: PropTypes.bool,
  noteKey: PropTypes.string,
};

export default ChecklistResponseNote;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/checklistResponseNote.jsx